import React, { Component } from 'react';
import guideImg from '../../static/images/guide.png';
import btnImg from '../../static/images/guide_btn.png';
import './style.less';


class Guide extends Component {
    constructor(props){
        super(props);
        this.state = {};  
        this.handleClick = props.handleClick;
        console.log(props)
    }
    
    render(){
        
        return(
            <div className="box_wrap">
               <img src={guideImg} alt="图片" className='guideImg'/>
               <img src={btnImg} alt="图片" className='btnImg' onClick={this.handleClick}/>
            </div>
        )
    }
}

export default Guide;



// WEBPACK FOOTER //
// ./src/template/Share/Guide.jsx